module.exports = __webpack_public_path__ + "img/pathology_age.ccbbc8ef.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pathology_age.gif
// module id = W7JD
// module chunks = 0